import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { finalize } from 'rxjs/operators';
import { IdentityStorage } from 'src/app/auth/_models/identity.storage';
import { RequerimentoDTO } from 'src/app/model/dto/requerimento.dto';
import { RequerimentoSimplesDTO } from 'src/app/model/dto/requerimentoSimples.dto';
import { Acoes } from 'src/app/model/enum/acoes.enum';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import { RequerimentoService } from 'src/app/service/requerimento.service';
import { TrocarSenhaService } from 'src/app/service/trocar-senha/trocar-senha.service';

@Component({
  selector: 'app-solicitacao-advogado',
  templateUrl: './solicitacao-advogado.component.html',
  styleUrls: ['./solicitacao-advogado.component.css']
})
export class SolicitacaoAdvogadoComponent implements OnInit, AfterViewInit {
  private readonly idAdvogado;
  private isLoading = false;

  // Grid Solicitações
  displayedColumns: string[] = ['edital', 'precatorio', 'credor', 'dataSolicitacao', 'acao'];
  dataSource = new MatTableDataSource<RequerimentoSimplesDTO>();
  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private trocaSenhaService: TrocarSenhaService,
    private identityStorage: IdentityStorage,
    private requerimentoService: RequerimentoService,
    private dataTransfer: DataTransferService,
    private router: Router,
    public local: LocalStorageService) {
    this.idAdvogado = identityStorage.getIdentity().id;
  }


  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.resetPassword();
    this.searchData();
    this.local.set('rotaAnterior', 'listar-solicitacoes-advogado');
    this.local.set('home', 'listar-solicitacoes-advogado');
  }

  resetPassword() {
    const { resetPassword } = this.identityStorage.getIdentity();

    if (resetPassword === 'true') {
      this.trocaSenhaService.abrirModalTrocaDeSenha();
    }
  }

  searchData() {
    this.isLoading = true;
    this.requerimentoService.buscarPorIdAdvogado(this.idAdvogado)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: ({ data }) => {
          this.dataSource.data = data;
        },
        error: (err) => console.log(err)
      })
  }

  novoRequerimento() {
    this.router.navigate(['solicitacao']);
  }

  visualizarSolicitacao(solicitacao: RequerimentoSimplesDTO) {
    this.requerimentoService.buscarPorId(solicitacao.id).subscribe(({ data }) => {
      this.dataTransfer.setData(data)
      this.router.navigate(["formulario/consultar/",solicitacao.id])
    });
  }

  editarSolicitacao(solicitacao: RequerimentoSimplesDTO) {
    this.requerimentoService.buscarPorId(solicitacao.id).subscribe(({ data }) => {
      this.dataTransfer.setData(data)
      this.router.navigate(["formulario/editar/",solicitacao.id])
    });
  }

  compactar(requerimento: RequerimentoDTO) {
    this.requerimentoService.buscarPorId(requerimento.id).subscribe(({ data }) => {
      this.navegarComDados(data, Acoes.ZIP);
    });
  }
  
private navegarComDados(requerimento: RequerimentoDTO | RequerimentoDTO[], acao: Acoes) {
  this.dataTransfer.setData({ requerimento: Array.isArray(requerimento) ? requerimento : [requerimento], acao });
  this.router.navigate(['impressao-inscritos']);
}

  get dataSourceLength() {
    return this.dataSource.data.length;
  }

}

